// extracted by css-extract-rspack-plugin
export default {"Banner":"AppInstallBannerPartial-module__Banner__BjYdP"};